export const htmlIds = {
  loginForm: 'loginForm',
  googleLogin: 'googleLogin',
  ulaApp: 'ula-app',
  organizationsContainer: 'organizationsContainer',
  applicationsContainer: 'applicationsContainer',
  goToAppBtn: 'goToAppBtn',
  logoutBtn: 'logoutBtn',
  userDisplayName: 'userDisplayName',
  impersonateDialog: 'impersonateDialog',
  impersonateInput: 'impersonateInput',
  impersonateConfirmBtn: 'impersonateConfirmBtn',
  impersonateCancelBtn: 'impersonateCancelBtn',
  stopImpersonationBtn: 'stopImpersonationBtn',
  stagingBanner: 'ulaStagingBanner',
  debugToggleBannerBtn: 'debugToggleBannerBtn',
  debugErrorToastBtn: 'debugErrorToastBtn',
} as const;
